<template>
  <div style="position: relative; z-index: 999;">
    <div :class="isbook ? 'bookbreadcrumb' : breads ? 'breads' : 'bread'" v-if="this.switch">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in levelList" v-show="index < levelList.length - 1" :key="index"
          :to="item.path">{{ item.meta.title }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ levelList[levelList.length - 1].meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      levelList: null,
      switch: true,
      breads: false,
      isbook: false
    };
  },
  updated() {
    // console.log(this.$route);
  },
  created() {
    this.getBreadcrumb();
    console.log(this.$route.fullPath);
  },
  watch: {
    $route(route) {
      this.getBreadcrumb();
    }
  },
  methods: {
    getBreadcrumb() {
      console.log(this.$route)
      if (this.$route.name == '随堂练习') {
        let metatitle = ""
        if (this.$route.query.activityType == 1) {
          metatitle = "随堂检测"
        } else {
          metatitle = "调查问卷"
        }
        this.levelList = [{
          meta: {
            title: '首页'
          },
          path: '/index'
        }, {
          meta: {
            title: metatitle
          }
        }]
        return
      }
      if (this.$route.name == '随堂详情') {
        let metatitle = ""
        if (this.$route.query.activityType == 1) {
          metatitle = "随堂详情"
        } else {
          metatitle = "问卷详情"
        }
        this.levelList = [{
          meta: {
            title: '首页'
          },
          path: '/index'
        }, {
          meta: {
            title: metatitle
          }
        }]
        return
      }
      let matched = this.$route.matched.filter(
        item => item.meta && item.meta.title
      );
      const first = matched[0];
      if (!this.isDashboard(first)) {
        matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
      }
      this.levelList = matched.filter(item => item.meta && item.meta.title);
      if (this.$route.query.fromType) {
        let obj = {
          path: this.$route.query.fromType,
          meta: { title: "书架" },
          toPath: "/bookstore/index"
        };
        this.levelList = this.levelList.map(iTag =>
          iTag.path === obj.toPath ? obj : iTag
        );
      }
      this.switch = this.levelList.length === 1 ? false : true;
      if (
        this.levelList[this.levelList.length - 1].path ==
        "/willingLearn/courseQuestions"
      ) {
        this.breads = true;
      } else {
        if (this.levelList[this.levelList.length - 1].path.includes('bookstoreDetail')) {
          this.isbook = true;
        } else {
          this.isbook = false;
          this.breads = false;
        }
      }
      // 判断是否为练习模式
      if (this.$route.name == '在线考试') {
        let name = this.$route.query.answerType == 'practice'
        if (name) {
          this.levelList[this.levelList.length - 1].meta.title = '在线练习'
        } else {
          this.levelList[this.levelList.length - 1].meta.title = '在线考试'
        }
        console.log(this.levelList, 'this.$routethis.$routethis.$route');
      }
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim() === "首页";
    }
  }
};
</script>
<style scoped lang="scss">
.bread {
  width: 1400px;
  margin: 0 auto;
  padding: 20px 0;
}

.breads {
  width: 100%;
  margin-left: 20px;
  padding: 20px 0;
}

::v-deep .bookbreadcrumb {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;

  .el-breadcrumb__item {
    .el-breadcrumb__inner {
      font-weight: 400;
      color: rgba(255, 255, 255, 0.5);
    }
  }

  .el-breadcrumb__item:last-child {
    .el-breadcrumb__inner {
      color: #fff;
    }
  }
}

// >>>.el-breadcrumb {
//   .el-breadcrumb__item:last-of-type {
//     span {
//       color: #3365a0;
//     }
//   }
// }</style>
